import React from "react";
import ReactDOM from "react-dom";
import { QueryClient, QueryClientProvider } from "react-query";
import { ReactQueryDevtools } from "react-query/devtools";

import 'bootstrap/dist/css/bootstrap.min.css';
import "react-modern-calendar-datepicker/lib/DatePicker.css";
import { ThemeProvider } from "styled-components";
import { GlobalStyle } from "./theme/generalStyle";
import theme from "./theme/schema.json";

import App from "./App";
import reportWebVitals from "./reportWebVitals";
const queryClient = new QueryClient();

ReactDOM.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <ThemeProvider theme={theme}>
        <GlobalStyle />
        <App />
      </ThemeProvider>
      <ReactQueryDevtools />
    </QueryClientProvider>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
